import React, { useState } from 'react'
import actI from './actI.module.css'
import { MdOutlineDashboard } from 'react-icons/md'
import { LuFileSliders } from 'react-icons/lu'
import { CiSettings } from 'react-icons/ci'
import imgI from '../../../img/img25.png'
import imgi from '../../../img/img10.png'
import imgii from '../../../img/img7.png'
import imgiii from '../../../img/img17.png'
import imgiv from '../../../img/img7.png'
import imgv from '../../../img/img7.png'
import { Link } from 'react-router'

const acticleRI = () => {

    // const [Search, setSearch] = useState('')


  return (
    <div className={actI.actI}>
        <div className={actI.container}>
            <div className={actI.content}>
                <div className={actI.block}>
                    <div className={actI.blocki}>
                        <div className={actI.seci}>
                            <div className={actI.icon}>
                                <MdOutlineDashboard />
                                
                                <h3>Dashboard</h3>
                            </div>
                            <div className={actI.icon}>
                                <LuFileSliders />
                                <h3>Article Review</h3>
                            </div>
                        </div>
                        <div className={actI.seciI}>
                            <div className={actI.icon}>
                                <CiSettings />
                                <h3>Settings</h3>
                            </div>
                            <div className={actI.icon}>                               
                                <h3>Logout</h3>
                            </div>
                        </div>
                    </div>
                    
                    <div className={actI.blockiv}>
                        <div className={actI.seciii}>
                            <h3>Articles</h3>
                            <Link>See all</Link>
                        </div>
                        <div className={actI.flexi}>
                            <div className={actI.cardi}>
                                <img src={imgI} alt="" />
                                <button className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>
                            <div className={actI.cardi}>
                                <img src={imgi} alt="" />
                                <button  className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>
                            <div className={actI.cardi}>
                                <img src={imgii} alt="" />
                                <button className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>
                            <div className={actI.cardi}>
                                <img src={imgiii} alt="" />
                                <button className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>
                            <div className={actI.cardi}>
                                <img src={imgiii} alt="" />
                                <button className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>
                            <div className={actI.cardi}>
                                <img src={imgiii} alt="" />
                                <button className={actI.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button className={actI.btnii}>View</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default acticleRI
